/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  Tabs,
  Tab,
  Switch,
  FormControlLabel,
  Avatar,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import './Perfomance.css';
import { useAppSelector, useAppDispatch } from '../../infra/hooks';
import CustomCircleProfilePic from '../../common/components/CustomCircleProfilePic';
import EmployeeFullName from '../../common/components/EmployeeFullName';
import EmployeeDesignation from '../../common/components/EmployeeDesignation';
import GoalsController from '../../domain/perfomance/Goals/GoalsController';
import BestPerfomerController from '../../domain/perfomance/BestPerfomer/BestPerfomerController';
import TopPerformerController from '../../domain/perfomance/TopPerformer/TopPerformerController';
import GoalsRatioController from '../../domain/perfomance/GoalsRatio/GoalsRatioController';
import ReviewsController from '../../domain/perfomance/Reviews/ReviewsController';
import FeedbackController from '../../domain/perfomance/Feedback/FeedbackController';
import GoalDetailViewController from '../../domain/perfomance/GoalDetailView/GoalDetailViewController';
import { fonts } from '../../common/themes/themes';
import TeamReviewsController from '../../domain/perfomance/TeamReviews/TeamReviewsController';
import TeamFeedbackController from '../../domain/perfomance/TeamFeedback/TeamFeedbackController';
import total_task_perfomance from '../../assets/images/total_task_perfomance.svg';
import todo_task_perfomance from '../../assets/images/todo_task_perfomance.svg';
import inprogress_task_perfomance from '../../assets/images/inprogress_task_perfomance.svg';
import completed_task_perfomance from '../../assets/images/completed_task_perfomance.svg';
import KPIPerfomanceController from '../../common/components/PerfomanceTabs/KPIPerfomance/KPIPerfomanceController';
import FeedbackPerfomanceController from '../../common/components/PerfomanceTabs/FeedbackPerfomance/FeedbackPerfomanceController';
import { setPerformanceSwitch } from '../../infra/aggregates/myProfile/Performance/Performance';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#4CAF50', // Green color for the switch when it is on (checked state)
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#4CAF50', // Green background color for the switch when it is on (checked state)
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track + .MuiSwitch-thumb': {
    backgroundColor: '#4CAF50', // Green color for the thumb when the switch is on (checked state)
  },
  '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled': {
    color: theme.palette.action.disabled, // Adjust color for checked but disabled state
  },
  '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track': {
    backgroundColor: theme.palette.action.disabled, // Adjust background color for checked but disabled state
  },
  '& .MuiSwitch-switchBase': {
    color: '#0066ff', // Blue color for the switch when it is off (unchecked state)
  },
  '& .MuiSwitch-switchBase + .MuiSwitch-track': {
    backgroundColor: '#0066ff', // Blue background color for the switch when it is off (unchecked state)
  },
  '& .MuiSwitch-switchBase.Mui-disabled': {
    color: theme.palette.action.disabled, // Adjust color for disabled state
  },
  '& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track': {
    backgroundColor: theme.palette.action.disabled, // Adjust background color for disabled state
  },
}));

interface propsType {
  EmpDirectory: any;
  allDepartment: any;
  isLoading?: boolean;
  setPageChange?: any;
  totalEmpDirectory: any;
  trans?: any;
  i18n?: any;
  profilePic?: any;
  empFirstName?: any;
  empLastName?: any;
  empDesignation?: any;
}

const PerfomancePresenter: React.FC<propsType> = ({
  i18n,
  trans,
}) => {
  const dispatch = useAppDispatch();
  const performanceSwitch = useAppSelector(
    (state) => state.PerformanceSlice?.performanceSwitch,
  );
  const [value, setValue] = React.useState('kpi');
  const [isMyTeam] = React.useState(false);
  const [showGoalsDetailView, setShowGoalsDetailView] = React.useState(false);
  const [showGoalsDetailViewData, setShowGoalsDetailViewData] =
    React.useState(false);

  const [selectedEmployee, setSelectedEmployee] = useState<any>({});
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);
  const employeesData: any = useAppSelector(
    (state) => state.PerformanceSlice?.employeeData,
  );
  const myTeamEmployees = useAppSelector(
    (state) => state.PerformanceSlice?.myTeamEmployees,
  );
  const { get_emp_details } = employeesData || {};

  const handleGoalsView = (data: any) => {
    if (data) {
      setShowGoalsDetailView(data?.isOpen);
      setShowGoalsDetailViewData(data?.data);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: isHRView ? '1em' : '4em',
        height: '100%',
        width: 'calc(100vw - 8em)',
        marginLeft: '0.1em',
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          backgroundColor: '#F5F5FA',
          height: '100%',
          marginRight: i18n.language == 'ar' ? '6em' : '',
          padding: '1em',
        }}
      >
        <Grid item xs={2} sm={2} md={2} lg={2}>
          <Box
            sx={{
              height: '100%',
              backgroundColor: 'white',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingY: '2em',
              paddingX: '1em',
              marginLeft: '-2em',
            }}
          >
            <CustomCircleProfilePic
              profilePic={{
                award: '',
                pic: get_emp_details?.user?.profile_pic,
              }}
            />
            <Box style={{ marginTop: '0.5em' }} />
            <EmployeeFullName
              first_name={get_emp_details?.first_name}
              last_name={get_emp_details?.last_name}
            />

            <EmployeeDesignation
              designation={get_emp_details?.emp_job_detail?.designation?.name}
            />

            <Box
              sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-around',
                backgroundColor: '#FAFAFA',
                borderRadius: '0.5em',
                padding: '0.3em',
                marginTop: '1em',
              }}
            >
              <Box>
                <Typography
                  style={{
                    color: !performanceSwitch ? '#0066ff' : '#0000008A',
                    fontSize: '0.7em',
                    fontFamily: 'Lato',
                    fontWeight: !performanceSwitch ? 'bold' : '',
                  }}
                >
                  {trans('My-Performance')}
                </Typography>
              </Box>
              <Box>
                <FormControlLabel
                  label={''}
                  control={
                    <CustomSwitch
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>,
                      ) => {
                        dispatch(setPerformanceSwitch(event.target.checked));
                      }}
                      checked={performanceSwitch}
                    />
                  }
                />
              </Box>
              <Box>
                <Typography
                  style={{
                    color: performanceSwitch ? '#4CAF50' : '#0000008A',
                    fontSize: '0.7em',
                    fontFamily: 'Lato',
                    fontWeight: performanceSwitch ? 'bold' : '',
                  }}
                >
                  {trans('My Team')}
                </Typography>
              </Box>
            </Box>
            {/*{performanceSwitch && (*/}
            {/*  <>*/}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                marginTop: '1em',
              }}
            >
              <Box>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: '0.825em',
                    color: '#000000',
                    fontWeight: 'bold',
                  }}
                >
                  {trans('My Team')}
                </Typography>
              </Box>
              <Box>
                {' '}
                <Typography
                  style={{
                    color: '#9E9E9E',
                    fontFamily: fonts.fontFamily,
                    fontSize: '0.725em',
                  }}
                >
                  {`${trans('Total')}: ${myTeamEmployees?.length}`}
                </Typography>
              </Box>
            </Box>
            {myTeamEmployees?.map((data: any) => {
              return (
                <Box
                  sx={{
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    backgroundColor:
                      selectedEmployee?.status &&
                      selectedEmployee?.empId == data?.id
                        ? '#7C0E6F14'
                        : '#FAFAFA',
                    borderRadius: '0.5em',
                    padding: '0.5em',
                    marginTop: '1em',
                  }}
                  key={data?.id}
                  onClick={() => {
                    setSelectedEmployee({
                      status: true,
                      empId: data?.id,
                    });
                  }}
                >
                  <Box>
                    <Avatar
                      style={{
                        background: 'transparent 0% 0% no-repeat padding-box',
                        boxShadow: '0px 3px 6px #00000029',
                        border: '3px solid #ffffff',
                        opacity: '1',
                        height: '1.563em',
                        width: '1.563em',
                        borderRadius: '50%',
                      }}
                      src={data?.profileImage}
                    />
                  </Box>
                  <Box style={{ marginLeft: '1em' }}>
                    <Typography
                      style={{
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.825em',
                        color: '#000000',
                        fontWeight: 'bold',
                      }}
                    >
                      {data?.name}
                    </Typography>
                    <Typography
                      style={{
                        color: '#9E9E9E',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.725em',
                      }}
                    >
                      {data?.desig}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
            {/*  </>*/}
            {/*)}*/}
          </Box>
        </Grid>
        <Grid item xs={10} sm={10} md={10} lg={10}>
          {showGoalsDetailView ? (
            <GoalDetailViewController
              goalData={showGoalsDetailViewData}
              handleClose={(val: any) => setShowGoalsDetailView(val)}
            />
          ) : (
            <Box>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{
                    marginTop: '1.75em',
                    padding: '1em',
                  }}
                >
                  <Box
                    sx={{
                      height: '100%',
                      width: 'calc(100% - 1em)',
                      background: '#FFFFFF 0% 0% no-repeat padding-box',
                      borderRadius: '10px',
                      opacity: '1',
                      display: 'flex',
                      flexDirection: 'row',
                      paddingTop: '0.4em',
                      paddingLeft: '1em',
                      paddingRight: '1em',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="secondary tabs example"
                        style={{ fontFamily: 'Lato' }}
                      >
                        <Tab
                          value="kpi"
                          label={trans('KPI')}
                          style={{
                            fontFamily: 'Lato',
                            fontWeight: 'bold',
                            fontSize: '0.725em',
                            textTransform: 'capitalize',
                          }}
                        />

                        <Tab
                          value="feedback"
                          label={trans('Feedback')}
                          style={{
                            fontFamily: 'Lato',
                            fontWeight: 'bold',
                            fontSize: '0.725em',
                            textTransform: 'capitalize',
                          }}
                        />
                      </Tabs>
                    </Box>
                    <Box style={{ display: 'flex' }}>
                      <Box
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <i
                          className="las la-chart-pie"
                          style={{
                            fontSize: '0.7em',
                            paddingRight: '0.5em',
                            color: 'black',
                            paddingTop: '0.1em',
                          }}
                        ></i>
                        <Typography
                          style={{
                            fontSize: '0.7em',
                            color: 'black',
                            fontFamily: 'Lato',
                          }}
                        >
                          {trans('Dashboard')}
                        </Typography>
                      </Box>
                      <Box
                        style={{
                          marginLeft: '1em',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          style={{
                            width: '4px',
                            height: '4px',
                            backgroundColor: '#BDBDBD',
                            borderRadius: '10px',
                            marginRight: '0.5em',
                          }}
                        ></Box>
                        <Typography
                          style={{
                            fontSize: '0.7em',
                            color: '#9E9E9E',
                            fontFamily: 'Lato',
                          }}
                        >
                          {value === 'goals/kra' ? 'Goals' : 'Reviews'}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>

              {value == 'kpi' ? (
                <KPIPerfomanceController trans={trans} myTeam={isMyTeam} />
              ) : value == 'feedback' ? (
                <FeedbackPerfomanceController trans={trans} />
              ) : value == 'goals/kra' ? (
                <>
                  {' '}
                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      <Box
                        sx={{
                          padding: '0.75em',
                          backgroundColor: 'white',
                          boxShadow: '0px 1px 2px #00000029',
                          width: 'auto',
                          height: 'auto',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box>
                          <Typography
                            style={{
                              color: '#0000008A',
                              fontSize: '0.75em',
                              fontWeight: 'bold',
                              fontFamily: 'Lato',
                            }}
                          >
                            {trans('Total Task')}
                          </Typography>
                          <Typography
                            style={{
                              color: '#000000',
                              fontSize: '0.75em',
                              fontWeight: 'bold',
                              fontFamily: 'Lato',
                            }}
                          >
                            T200
                          </Typography>
                        </Box>
                        <Box
                          style={{
                            backgroundColor: '#7C0E6F14',
                            width: '1.5em',
                            height: '1.5em',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px',
                          }}
                        >
                          <img
                            src={total_task_perfomance}
                            style={{
                              width: '1em',
                              height: '1em',
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={3}>
                      <Box
                        sx={{
                          padding: '0.75em',
                          backgroundColor: 'white',
                          boxShadow: '0px 1px 2px #00000029',
                          width: 'auto',
                          height: 'auto',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box>
                          <Typography
                            style={{
                              color: '#0000008A',
                              fontSize: '0.75em',
                              fontWeight: 'bold',
                              fontFamily: 'Lato',
                            }}
                          >
                            To do Task
                          </Typography>
                          <Typography
                            style={{
                              color: '#000000',
                              fontSize: '0.75em',
                              fontWeight: 'bold',
                              fontFamily: 'Lato',
                            }}
                          >
                            T200
                          </Typography>
                        </Box>
                        <Box
                          style={{
                            backgroundColor: '#F6F6F6',
                            width: '1.5em',
                            height: '1.5em',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px',
                          }}
                        >
                          <img
                            src={todo_task_perfomance}
                            style={{
                              width: '1em',
                              height: '1em',
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={3}>
                      <Box
                        sx={{
                          padding: '0.75em',
                          backgroundColor: 'white',
                          boxShadow: '0px 1px 2px #00000029',
                          width: 'auto',
                          height: 'auto',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box>
                          <Typography
                            style={{
                              color: '#0000008A',
                              fontSize: '0.75em',
                              fontWeight: 'bold',
                              fontFamily: 'Lato',
                            }}
                          >
                            Task in Progress
                          </Typography>
                          <Typography
                            style={{
                              color: '#000000',
                              fontSize: '0.75em',
                              fontWeight: 'bold',
                              fontFamily: 'Lato',
                            }}
                          >
                            T200
                          </Typography>
                        </Box>
                        <Box
                          style={{
                            backgroundColor: '#FFF5E5',
                            width: '1.5em',
                            height: '1.5em',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px',
                          }}
                        >
                          <img
                            src={inprogress_task_perfomance}
                            style={{
                              width: '1em',
                              height: '1em',
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={3}>
                      <Box
                        sx={{
                          padding: '0.75em',
                          backgroundColor: 'white',
                          boxShadow: '0px 1px 2px #00000029',
                          width: 'auto',
                          height: 'auto',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box>
                          <Typography
                            style={{
                              color: '#0000008A',
                              fontSize: '0.75em',
                              fontWeight: 'bold',
                              fontFamily: 'Lato',
                            }}
                          >
                            Completed Task
                          </Typography>
                          <Typography
                            style={{
                              color: '#000000',
                              fontSize: '0.75em',
                              fontWeight: 'bold',
                              fontFamily: 'Lato',
                            }}
                          >
                            T200
                          </Typography>
                        </Box>
                        <Box
                          style={{
                            backgroundColor: '#EDF7ED',
                            width: '1.5em',
                            height: '1.5em',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px',
                          }}
                        >
                          <img
                            src={completed_task_perfomance}
                            style={{
                              width: '1em',
                              height: '1em',
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <GoalsController passGoalDetail={handleGoalsView} />
                    </Grid>
                    <Grid item xs={4}>
                      <BestPerfomerController />
                    </Grid>
                    <Grid item xs={4}>
                      <TopPerformerController />
                    </Grid>
                    <Grid item xs={4}>
                      <GoalsRatioController />
                    </Grid>
                    <Grid item xs={4}>
                      {isMyTeam ? (
                        <TeamReviewsController />
                      ) : (
                        <ReviewsController />
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      {isMyTeam ? (
                        <TeamFeedbackController />
                      ) : (
                        <FeedbackController />
                      )}
                    </Grid>
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default PerfomancePresenter;
